import React from 'react'
import { Helmet } from 'react-helmet';
import { SportsData } from '../data/SportsData';
import { Link } from 'react-router-dom';

const Sports = () => {
  return (
    <div>
      <Helmet>
        <title>Sports </title>
      </Helmet>
      <div className='main-container'>
         <div className="page-bg"></div>
        <div className="page-bg page-bg2"></div>
        <div className="page-bg page-bg3"></div>
        <div className="section">
          <div className="page-heading">
            <h1>Sports</h1>
          </div>
          {SportsData.map((Sport, index) => {
            return (
              <div className="grid-1-3 sports-facility-card" key={index}>
                <div className='sports-facility-card-img'>
                  <Link to={`/sports/${Sport.SportsName}`} onClick={() => window.scrollTo(0, 0)}>
                    <img src={Sport.CardImage} alt='Sports' />
                  </Link>
                </div>
                <div className="sports-facility-card-cap">
                  <h2>{Sport.SportsName}</h2>
                  <p>{Sport.Para1}</p>
                  <div className="sports-facility-card-btn">
                    <Link to={`/sports/${Sport.SportsName}`} onClick={() => window.scrollTo(0, 0)}>
                      <button className='card-item-btn'>Find Out More </button></Link>
                  </div>
                </div>
              </div>


            )
          })}





        </div>

      </div>

    </div>

  )
}

export default Sports